import { types } from "mobx-state-tree";
import Team from "./Team";

const TeamStore = types
  .model('TeamStore', {
    teams: types.optional(types.array(Team), []),
  })
  .actions((self) => ({
    setTeams(teams) {
      let newTeams = [];
      for (let i = 0; i < teams.length; i++) {
        newTeams.push(Team.create(teams[i]));
      }
      self.teams = [...newTeams];
    },
    addTeam(team) {
      self.teams.push(team);
    },
    removeTeams(teams) {
      teams.forEach((t) => {
        self.teams.remove(t)
      });      
    },

    updateTeam(team) {
      let foundTeam = self.teams.find((t) => t.id === team.id);
      if (foundTeam) {
        foundTeam.setTeamName(team.name);
      }
    },
  }))
  .views(self => ({   
    isValidTeam(id) {
      return self.teams.find((t) => t.id === id);
    },
  }));

export default TeamStore;
